// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Select_componentWrapper__DzU+R","isSpecial":"Select_isSpecial__RLL-p"};